<template>
   <div>
      <!-- NAVBAR -->
      <my-navbar :controller="controller"/>
      <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">
         <div class="container-fluid">
            <div class="header-body">
               <div class="row">
                  <!-- CONTENIDO HEADER -->
                  <div class="col-lg-6 col-md-10 mb-5">
                     <h1 class="display-3 text-white">Campañas</h1>
                     <template v-if="!!campana.form.caption">
                        <p class="text-white mt-0 mb-0"><strong>Cliente:</strong> {{cliente.caption}}</p>
                        <p class="text-white"><strong>Formulario:</strong> {{ campana.form.caption }}</p>
                     </template>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- CONTENT -->
      <div class="container-fluid mt--7">
         <div class="row">
            <div class="col">
               <vue-good-wizard
                  class="ca-stepper"
                  :steps="steps"
                  :onNext="nextClicked"
                  :onBack="backClicked"
                  previousStepLabel="Atrás"
                  nextStepLabel="Siguiente"
                  finalStepLabel="Exportar"
                  >
                  <div slot="page1">
                     <div class="wizard-header">
                        <h4>Selecciona un cliente</h4>
                        <p>
                           Si no existe, puedes crearlo haciendo clic en
                           <u>Agregar Nuevo</u>.
                        </p>
                     </div>
                     <div class="card wizard-card card-cliente">
                        <div class="card-body">
                           <div class="form-group">
                              <label for="input-formulario">Clientes</label>
                              <v-select
                              class="select-search"
                                 style="width:100%;"
                                 placeholder="Buscar cliente"
                                 :options="clientes"
                                 label="caption"
                                 v-model="cliente"
                                 >
                                 <span slot="no-options">No hay resultados disponibles</span>
                              </v-select>
                           </div>
                           <button class="btn btn-link btn-sm" v-b-toggle="'newClient'" v-if="actions.post">
                           <i class="fa fa-plus-circle text-success"></i> Agregar nuevo
                           </button>
                           <!-- Element to collapse -->
                           <b-collapse id="newClient">
                              <div class="input-group">
                                 <input
                                    :disabled="loading"
                                    @keyup.enter="addClient()"
                                    type="text"
                                    class="form-control"
                                    placeholder="Nombre del cliente"
                                    v-model="newClient.caption"
                                    >
                                 <div class="input-group-append">
                                    <button
                                       class="btn btn-success"
                                       type="button"
                                       @click="addClient()"
                                       :disabled="loading || newClient.caption.trim().length < 1"
                                       >
                                    <i class="fa fa-plus-circle"></i>
                                    </button>
                                 </div>
                              </div>
                           </b-collapse>
                        </div>
                     </div>
                  </div>
                  <!--End page 1 -->
                  <div slot="page2">
                     <template v-if="cliente.campaigns && cliente.campaigns.length > 0">
                     <div class="wizard-header">
                        <h4>Campañas actuales</h4>
                     </div>
                     <div class="wizard-card card-forms">
                        <div class="card-body">
                           <div class="row">
                              <template v-for="(c, i) in cliente.campaigns">
                                 <div class="col-md-3 col-sm-4" v-for="f in filterForms(c)" :key="'FormCampana_' + i + '_' + f.id">
                                    <div class="card form-item shadow">
                                       <button
                                          class="btn btn-link"
                                          type="button"
                                          data-toggle="collapse"
                                          :data-target="'#collapse' + i"
                                          aria-expanded="false"
                                          :aria-controls="'collapse' + i"
                                          >
                                       {{ c.caption }}
                                       <i class="fa text-primary" :class="campana.form.id == f.id && campana.id == c.id ? 'fa-check text-success':'fa-plus'"></i>
                                       </button>
                                       <div class="collapse" :id="'collapse' + i">
                                          <div class="card-body text-small">
                                             <h5 class="text-small" >{{f.caption  || 'Sin nombre' }}</h5>
                                             <h5>Campos:</h5>
                                             <p class="text-small" v-if="f.fields.length == 0">Este formulario no tiene campos</p>
                                             <ol>
                                                <li v-for="field in f.fields" :key="'keyField_'+ field.id">{{field.caption}}</li>
                                             </ol>
                                             <div class="text-right" v-if="f.fields.length > 0">
                                                <button
                                                   class="btn btn-sm"
                                                   @click="setSelectedCampaign(c,f)"
                                                   v-text="campana.form.id == f.id  && campana.id == c.id ? 'Seleccionado':'Seleccionar'"
                                                   :class="campana.form.id == f.id  && campana.id == c.id ? 'btn-primary':'btn-secondary'"
                                                   >Seleccionar</button>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </template>
                           </div>
                        </div>
                     </div>
                     <hr>
                     </template>

                     <div class="wizard-header bg-secondary">
                        <h4>Selecciona un formulario</h4>
                        <p>Haz clic en un item para ver los detalles y luego seleccionar.</p>
                        <p>
                           También puedes
                           <router-link :to="{ name: 'createDFPForm' }" class="btn btn-sm btn-link">
                              <i class="fa fa-plus-circle text-success"></i> Crear nuevo
                           </router-link>
                        </p>
                     </div>

                     <div class="wizard-card card-forms bg-secondary">

                        <p class="text-center" v-if="forms.length == 0">No hay formularios creados</p>

                        <div class="card-body">
                           <div class="row">
                              <div class="col-md-3 col-sm-4" v-for="f in forms" :key="f.id">
                                 <div class="card form-item shadow">
                                    <button
                                       class="btn btn-link"
                                       type="button"
                                       data-toggle="collapse"
                                       :data-target="'#collapseForm' + f.id"
                                       aria-expanded="false"
                                       :aria-controls="'collapseForm' + f.id"
                                       >
                                    {{f.caption  || 'Sin nombre' }}
                                    <i class="fa text-primary" :class="campana.form.id == f.id && campana.id == 0 ? 'fa-check text-success':'fa-plus'"></i>
                                    </button>
                                    <div class="collapse" :id="'collapseForm' + f.id">
                                       <div class="card-body text-small">
                                          <h5>Campos:</h5>
                                          <p class="text-small" v-if="f.fields.length == 0">Este formulario no tiene campos</p>
                                          <ol>
                                             <li v-for="field in f.fields" :key="field.id">{{field.caption}}</li>
                                          </ol>
                                          <div class="text-right" v-if="f.fields.length > 0">
                                             <button
                                                class="btn btn-sm"
                                                @click="setSelectedCampaign(null, f)"
                                                v-text="campana.form.id == f.id && campana.id == 0 ? 'Seleccionado':'Seleccionar'"
                                                :class="campana.form.id == f.id && campana.id == 0 ? 'btn-primary':'btn-secondary'"
                                                >Seleccionar</button>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <!--End page 2 -->
                  <div slot="page3">
                     <div class="wizard-header">
                        <h4>Personaliza tu campaña</h4>
                        <p>Ingresa la información que conforma el formulario.</p>
                     </div>
                     <div class="card wizard-card card-customization">
                        <div class="card-body">
                           <div class="row">
                              <div class="col-md-8 col-sm-12">
                                 <div class="row">
                                    <div class="col-md-6">
                                       <div class="form-group">
                                          <label for>Título</label>
                                          <input
                                             type="text"
                                             class="form-control form-control-alternative"
                                             placeholder="Título del formulario"
                                             v-model="campana.caption"
                                             >
                                          <small class="form-text text-muted">Para uso interno. No se verá en el formulario.</small>
                                       </div>
                                    </div>
                                    <div class="col-md-6">
                                       <div class="form-group">
                                          <label>Descripción</label>
                                          <input
                                             type="text"
                                             class="form-control form-control-alternative"
                                             placeholder="Breve descripción"
                                             v-model="campana.descripcion"
                                             >
                                          <small class="form-text text-muted">Para uso interno. No se verá en el formulario.</small>
                                       </div>
                                    </div>
                                    <div class="col-md-6">
                                       <div class="form-group">
                                          <label for>Mensaje de éxito</label>
                                          <input
                                             type="text"
                                             class="form-control form-control-alternative text-success"
                                             placeholder="Mensaje que se muetra al enviar el lead"
                                             v-model="campana.mensaje.exito"
                                             >
                                       </div>
                                    </div>
                                    <div class="col-md-6">
                                       <div class="form-group">
                                          <label for>Mensaje de error</label>
                                          <input
                                             type="text"
                                             class="form-control form-control-alternative text-danger"
                                             placeholder="Mensaje que se muetra al enviar el lead"
                                             v-model="campana.mensaje.error"
                                             >
                                       </div>
                                    </div>
                                    <div class="col-md-12">
                                       <div class="form-group">
                                          <label for>Imagen de fondo</label>
                                          <input
                                             type="url"
                                             class="form-control form-control-alternative"
                                             placeholder="Pegar aquí la URL de imagen"
                                             v-model="campana.imagen"
                                             >
                                       </div>
                                    </div>
                                 </div>
                                 <div class="row">
                                    <div class="col-md-12">
                                       <hr>
                                       <h4 class="mb-20">Personalización de botón</h4>
                                    </div>
                                    <div class="col-md-4">
                                       <div class="form-group">
                                          <label for>Texto</label>
                                          <input type="text" class="form-control form-control-alternative" v-model="campana.boton.caption" placeholder="Ej: Cotiza aquí, Cotizar, etc">
                                       </div>
                                    </div>
                                    <div class="col-md-4">
                                       <div class="form-group">
                                          <label for>Color de fondo</label>
                                          <input type="color" class="form-control form-control-alternative" v-model="campana.boton.color">
                                       </div>
                                    </div>
                                    <div class="col-md-4">
                                       <div class="form-group">
                                          <label for>Color de texto</label>
                                          <input type="color" class="form-control form-control-alternative" v-model="campana.boton.textcolor">
                                       </div>
                                    </div>
                                 </div>
                                 <div class="row">
                                    <div class="col-md-12">
                                       <hr>
                                       <h4 class="mb-20">Destinatarios</h4>
                                    </div>
                                    <div class="col-md-6">
                                       <div class="form-group" v-if="actions.post">
                                          <label for>Agregar emails de destinatarios</label>
                                          <div class="input-group">
                                             <input
                                                type="text"
                                                class="form-control"
                                                placeholder="Ingresa un email válido"
                                                v-model="newEmail"
                                                @keyup.enter="addEmail()"
                                                >
                                             <div class="input-group-append">
                                                <button
                                                   class="btn btn-success"
                                                   type="button"
                                                   @click="addEmail()"
                                                   :disabled="newEmail.trim().length < 6"
                                                   >
                                                <i class="fa fa-plus-circle"></i>
                                                </button>
                                             </div>
                                          </div>
                                          <small class="form-text text-muted">Para uso interno. No se verá en el formulario.</small>
                                       </div>
                                       <div class="alert text-info" v-if="!campana.destinatarios.length">
                                          <i class="fa fa-info-circle"></i> No has ingresado destinatarios
                                       </div>
                                       <ol v-else>
                                          <li class="fadeInUp"
                                             v-for="(i, indexEmail) in campana.destinatarios"
                                             :key="'emailskey_' + indexEmail"
                                             >
                                             {{i}}
                                             <button
                                                class="btn btn-icon btn-2 btn-link text-danger btn-sm"
                                                title="Eliminar"
                                                type="button"
                                                @click="deleteEmail(indexEmail)"
                                                v-if="actions.delete"
                                                >
                                             <span class="btn-inner--icon">
                                             <i class="fa fa-trash"></i>
                                             </span>
                                             </button>
                                          </li>
                                       </ol>
                                    </div>
                                 </div>
                              </div>
                              <div class="col-md-4 col-sm-12 bg-secondary">
                                 <div class="card1">
                                    <div class="card-body">
                                       <div class="form-group">
                                          <label for>Selecciona una Plantilla</label>
                                          <select class="form-control form-control-alternative" v-model="template">
                                             <option value="0">---</option>
                                             <option value="1">Plantilla 1</option>
                                             <option value="2">Plantilla 2</option>
                                             <option value="3">Plantilla 3</option>
                                          </select>
                                       </div>
                                       <h4 class="text-center">Previsualización</h4>
                                       <div class="previsual-container">
                                          <div class="btn-group btn-controls btn-group-sm">
                                             <button class="btn btn-secondary" @click="fieldsUp"><i class="ni ni-bold-up"></i></button>
                                             <button class="btn btn-secondary" @click="fieldsDown"><i class="ni ni-bold-down"></i></button>
                                          </div>
                                          <Previsualizador :campana="campana" :template="template" :fieldsPosition="fieldsPosition" :customPosition="customPosition" />
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="row mt-40">
                              <div class="col-md-12">
                                 <p class="text-right">
                                    Haz clic en
                                    <strong>
                                    <u>EXPORTAR</u>
                                    </strong> para generar el Script.
                                 </p>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <!--End page 3 -->
               </vue-good-wizard>
            </div>
         </div>
      </div>
      <b-modal ref="myModalRef" hide-footer title="Campaña DFP" description="test">
         <div class="d-block">
            <div class="card bg-secondary text-center text-small">
               {{campana.identifier}}
            </div>
            <br>
            <div class="card bg-secondary">
               <ModalExport :campana="campana" :template="template" :fieldsPosition="fieldsPosition" :customPosition="customPosition"/>               
            </div>
         </div>
         <b-button class="mt-3" variant="outline-danger" @click="hideModal">Cerrar</b-button>
         <b-button class="mt-3" variant="primary" @click="copyScript"><i class="fa fa-files-o"></i> Copiar </b-button>
      </b-modal>
   </div>
</template>
<script>

import _ from "underscore"
import Auth from '@/helpers/middleware'
import sysMsgs from "@/helpers/system.message"
import dfpServices from "@/services/dfp.services"
import { validation } from "@/helpers/validations"
import { Client, Campaign } from '@/views/marketing/campaigns/models/campaign.model';

import Previsualizador from '@/views/marketing/campaigns/_Previsualizador.vue'
import ModalExport from '@/views/marketing/campaigns/_ModalExport.vue'

export default {
  name: "CreateCampaign",
  components: {
    Previsualizador, ModalExport
  },
  data() {
   return {
   loading: false,
   actions: Auth.getActions(this.$route.name),
   fieldsPosition: 10,
   customPosition: true,
   controller: {
      title: "Marketing",
      mainRouter: "/"
   },
   template: 0,
   clientes: [],
   cliente: {
      campaigns: []
   },
   forms: [],
   newClient: new Client(),
   newEmail: "",
   campana: new Campaign(),
         steps: [
         {
            label: "Cliente",
            slot: "page1"
         },
         {
            label: "Formulario",
            slot: "page2"
         },
         {
            label: "Personalizar y Expotar",
            slot: "page3"
         }
         ]
      };
   },
   watch: {
      cliente: {
        handler(data){
          if(!data){
            this.cliente= {
               campaign: []
            };
          }
        }
      }
   },
  created(){
    this.getClientes();
    this.getForms();
  },
  methods: {
    fieldsUp() {
        this.fieldsPosition = this.fieldsPosition + 5
    },
    fieldsDown(){
        this.fieldsPosition  = this.fieldsPosition - 5
    },
    setSelectedCampaign(c,f){
      this.campana = c ? c : new Campaign(); 
      this.campana.ci_id = this.cliente.id
      this.campana.form = f
      this.campana.fe_id = f.id
    },
    filterForms(val){
      return _.filter(this.forms, filter => filter.id == val.fe_id);
    },
    getClientes() {
      this.loading = true;
      dfpServices.filtros
        .getClientes()
        .then(response => {
          this.clientes = response.data.lista;
          this.loading = false;
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.loading = false;
        });
    },
    getForms(){
      this.loading = true;
      dfpServices.forms.getAll().then(response => {
        this.forms = response.data.forms;
        this.loading = false;
      }).catch(error => {
        sysMsgs.getResponseMessage(error.response);
        this.loading = false;
      });
    },
    addClient() {
      if(this.newClient.caption.trim().length > 0)
        this.loading = true;
        dfpServices.clients.set(this.newClient).then(response => {
          this.cliente = response.data
          this.clientes.push(this.cliente);
          this.newClient = new Client();
          this.loading = false;
        }).catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.loading = false;
        });
    },
    addEmail() {
      if (validation.email(this.newEmail)) {
        this.campana.destinatarios.push(this.newEmail);
        this.newEmail = "";
      } else {
        sysMsgs.getMessage("Ingresa un Email válido.", "error");
      }
    },
    deleteEmail(index) {
      this.campana.destinatarios.splice(index, 1);
    },
    stepValidations(val) {
      switch (val) {
        case 0:
          if (!this.cliente.id) {
            sysMsgs.getMessage(
              "Selecciona un Cliente para continuar.",
              "warning"
            );
            return false;
          }
          this.campana.ci_id = this.cliente.id
          this.campana.fe_id = 0
          return true;
        case 1:
          if (!this.campana.form.id || this.campana.fe_id == 0) {
            sysMsgs.getMessage(
              "Selecciona un Formulario para continuar.",
              "warning"
            );
            return false;
          }
          return true;
        case 2:
        if(this.actions.post || this.actions.put) {
          if(this.template > 0 && this.campana.destinatarios.length > 0) {
            this.setCampaign()
          } else {
            sysMsgs.getMessage(this.campana.destinatarios.length > 0 ? "Selecciona una Plantilla.":"No has ingresado destinatarios", "warning");
            return false
          }
        } else {
           sysMsgs.getMessage("No tienes permisos para realizar esta acción.", "error");
        }

        default:
          break;
      }
    },
    nextClicked(currentPage) {
      return this.stepValidations(currentPage);
    },
    backClicked(currentPage) {
      if(currentPage == 1)
       this.campana = new Campaign();
      return true;
    },
    setCampaign(){ 
      dfpServices.campaigns.set(this.campana).then(response => {
        this.campana = response.data;
        this.$refs.myModalRef.show()
        sysMsgs.getMessage(
          "Campaña guardada correctamente.",
          "success"
        );
      }).catch(error => {
        sysMsgs.getResponseMessage(error.response);
      });
    },
    hideModal() {
      this.$refs.myModalRef.hide()
    },
    copyScript(){
      var copyText = document.getElementById("scriptboard");
      copyText.select();
      document.execCommand("copy");
        sysMsgs.getMessage("Copiado al portapapeles.", "info");
    }
  }
};
</script>
<style scoped>
.loading-overlay {
  min-height: 500px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 1);
}
.previsual-container {
   position: relative;
}
.btn-group.btn-controls {
    position: absolute;
    right: 5px;
    top: 5px;
   z-index: 10;
}
</style>
